import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountPage } from './account';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    AccountPage,
  ],
  imports: [
		PipesModule,
    ComponentsModule,
    IonicPageModule.forChild(AccountPage),
  ],
})
export class AccountPageModule {}



// WEBPACK FOOTER //
// ./src/pages/account/account.module.ts